import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function DeleteConfirmModal({
  showDeleteConfirmModal,
  setShowDeleteConfirmModal,
  deleteConfirmData,
  removeVoucher,
}) {
  return (
    <Modal
      show={showDeleteConfirmModal}
      onHide={() => setShowDeleteConfirmModal(false)}
    >
      <Modal.Header>
        <Modal.Title>Gutschein löschen</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Willst du den Gutschein "{deleteConfirmData.title}" von{" "}
          {deleteConfirmData.location} wirklich löschen?
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => setShowDeleteConfirmModal(false)}
        >
          Abbrechen
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            setShowDeleteConfirmModal(false);
            removeVoucher(deleteConfirmData.id);
          }}
        >
          Löschen
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteConfirmModal;
